var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21701_153958)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0377 11.0062C13.0102 11.0021 12.982 11 12.9534 11C12.8806 11 12.8092 11.0021 12.739 11.0062H12.6675V11.0112C10.9293 11.15 10 12.568 10 14.5762C10 14.8822 10.2509 15.1302 10.5603 15.1302H14.0628V27.42V28.0864H14.7237H28.2398V14.5762C28.2398 12.6037 26.6131 11.0062 24.6084 11.0062H13.0377ZM12.794 12.1135C11.8746 12.1782 11.3202 12.8118 11.1654 13.8998L11.1507 14.0219L14.0504 14.0222C13.9848 12.6917 13.6485 12.1594 12.794 12.1135ZM17.1454 17.1522C16.837 17.1522 16.5871 16.905 16.5871 16.6002C16.5871 16.2953 16.837 16.0482 17.1454 16.0482H22.4744C22.7827 16.0482 23.0327 16.2953 23.0327 16.6002C23.0327 16.905 22.7827 17.1522 22.4744 17.1522H17.1454ZM17.1454 20.4696C16.837 20.4696 16.5871 20.2224 16.5871 19.9176C16.5871 19.6127 16.837 19.3656 17.1454 19.3656H25.1572C25.4655 19.3656 25.7155 19.6127 25.7155 19.9176C25.7155 20.2224 25.4655 20.4696 25.1572 20.4696H17.1454ZM17.1454 23.6433H22.4744C22.7827 23.6433 23.0327 23.3961 23.0327 23.0913C23.0327 22.7864 22.7827 22.5393 22.4744 22.5393H17.1454C16.837 22.5393 16.5871 22.7864 16.5871 23.0913C16.5871 23.3961 16.837 23.6433 17.1454 23.6433Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21701_153958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.3b044524d828a5d7678628a3f9cbd118.svg";
export { ForwardRef as ReactComponent };